<template>
  <div>
    <div class="load-icon">
      <IconLoading loadingText="Authenticating..."></IconLoading>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import {
  computed, onMounted, watchEffect,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import apiManager from '@/api';
import IconLoading from '../components/loaders/IconLoading.vue';

const store = useStore();
const route = useRoute();
const router = useRouter();

const isAuthenticated = computed(() => store.getters['userStore/isAuthenticated']);

async function initialize() {
  if (route.query.code === undefined) {
    const url = await apiManager.login.loginUrl();
    window.location.replace(url);
  } else {
    try {
      await store.dispatch('userStore/getToken', {
        applicationId: store.getters['userStore/applicationId'],
        authCode: route.query.code,
      });
    } catch {
      router.push('unauthorized');
    }
  }
}

onMounted(() => {
  if (isAuthenticated.value) {
    router.push({ name: 'home' });
  } else {
    initialize();
  }
});

watchEffect(() => {
  if (isAuthenticated.value) {
    router.push({ name: 'home' });
  }
});
</script>

<style scoped>
.load-icon {
  margin-top: 300px;
}

.login-text {
  font-size: 2rem;
  text-align: center;
}
</style>
